import { runtimeServices } from '@/lib/runtime-services';
import { navigateApp } from '@/vite/navigation-store';

/** Crowdex's sign-in page (the service kit's `/signin` in the other apps). */
export const SIGNIN_PAGE = '/sign-in';

/**
 * Signs this browser out of Crowdex Cloud: its session ends, then the Crowlingo (Zitadel) session,
 * which comes back to `/sign-in`; straight to `/sign-in` when there is none to end.
 */
export async function signOutOfCloud(): Promise<void> {
  try {
    const url = await runtimeServices().signOut();
    if (url === null) navigateApp(SIGNIN_PAGE, true);
    else window.location.assign(url);
  } catch {
    navigateApp(SIGNIN_PAGE, true);
  }
}
